import React from "react"
import { IconButton, Tooltip } from "@material-ui/core"
import { OpenInNew } from "@material-ui/icons"

interface AssignationCreaLinkOpenProps {
    link: string | null
}

const AssignationCreaLinkOpen: React.FC<AssignationCreaLinkOpenProps> = ({ link }) => {

    const handleClick = () => {
        if (link) openInNewTab(link)
    }

    const openInNewTab = (url: string) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer') //https://dev.to/ben/the-targetblank-vulnerability-by-example
        if (newWindow) newWindow.opener = null
    }

    return <Tooltip title={"Abrir en nueva pestaña"}>
        <IconButton disabled={!link} onClick={event => { event.stopPropagation(); handleClick() }}>
            <OpenInNew />
        </IconButton>
    </Tooltip>

}

export default AssignationCreaLinkOpen